import clsx from 'clsx';
import { ReactNode } from 'react';
export const PageTitle = ({
  title,
  subtitle,
  actions,
  extra
}) => {
  return <div>
            <div className={clsx('grid items-center', !actions ? 'grid-cols-1' : 'sm:grid-cols-2 gap-2')}>
                <div>
                    <h1 className="text-2xl font-medium mb-1 text-foreground">{title}</h1>
                    {subtitle && <p className="text-sm text-foreground-muted">{subtitle}</p>}
                </div>
                {actions && <div className="flex items-center justify-end flex-wrap gap-4">{actions}</div>}
            </div>
            {extra && <div className="mt-4">{extra}</div>}
        </div>;
};